import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-izvestaj-o-popunjenosti-reklamnih-blokova',
  templateUrl: './izvestaj-o-popunjenosti-reklamnih-blokova.component.html',
  styleUrls: ['./izvestaj-o-popunjenosti-reklamnih-blokova.component.scss'],
})
export class IzvestajOPopunjenostiReklamnihBlokovaComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}



// WEBPACK FOOTER //
// ./src/app/pages/izvestaji/izvestaj-o-popunjenosti-reklamnih-blokova/izvestaj-o-popunjenosti-reklamnih-blokova.component.ts